import Modal from './modal';

(function () {
  let footerMenuItens = document.querySelectorAll('#menu-footer ul li');
  let size = footerMenuItens.length;

  if (size) {
    footerMenuItens.forEach(function (elem) {
      elem.classList.add('li-itens-' + size);
    });
  }

 
  // const btnAvisoCookiesCancel = document.querySelector('.btn-close-aviso-cookies');

  const oferecaTerreno = document.getElementsByClassName('assessoria');
  const modalOferecaTerreno = new Modal('#modal-assessoria', false);

  if (oferecaTerreno) {
    oferecaTerreno[0].addEventListener('click', function () {
      fnCloseMenu();
      modalOferecaTerreno.openModal();
    });

    document.getElementById('close-modal-assessoria').addEventListener('click', function () {
      modalOferecaTerreno.closeModal();
    });

    var opcoes = document.querySelectorAll('#modal-assessoria .btn-state');

    for (var i = 0; i < opcoes.length; i++) {

      opcoes[i].addEventListener('click', function () {
        document.querySelector('#modal-assessoria .subtitle').innerHTML =
          'em <b>' + this.dataset.uf_texto + '</b>';
        document.querySelector('#modal-assessoria .cidades').style.display = "none";
        document.querySelector('#modal-assessoria .contato').style.display = "block";

        if (this.dataset.exibir_chat == 1) {
          // clique para abrir o chat
          document.querySelector('#modal-assessoria .cadastrar').style.display = "block";
          var link = document.querySelector('#modal-assessoria .cadastrar a');
          link.href = link.dataset.link + '&uf=' + this.dataset.uf;
        }

        const linkContato = document.querySelector('#modal-assessoria .contato a');

        linkContato.href = "mailto:" + this.dataset.email;
        linkContato.innerHTML = this.dataset.email;

      });
    }
  }

  const fnCloseMenu = function () {
    document.body.classList.remove('opened-menu');
    document.body.classList.remove('opened-search-menu');
    document.documentElement.classList.remove('opened-search-menu');
    document.body.classList.add('menu-closing');

    window.setTimeout(() => {
      document.body.classList.remove('menu-closing');
    }, 200);
  }
})();